import { render, staticRenderFns } from "./itPrivacy.vue?vue&type=template&id=3732e716&scoped=true&"
import script from "./itPrivacy.vue?vue&type=script&lang=js&"
export * from "./itPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./itPrivacy.vue?vue&type=style&index=0&id=3732e716&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3732e716",
  null
  
)

export default component.exports